import type { HomeworkHistoryDetail } from 'src/dto'

import ExtendedMap from '@/models/ExtendedMap'

import { DTO } from '../DTO'

type Key = HomeworkHistoryDetail['studentHomeworkId']

export class HomeworkHistoryDetailColl extends DTO {
  map = new ExtendedMap<Key, HomeworkHistoryDetail>()

  constructor(arr?: HomeworkHistoryDetail[]) {
    super()
    if (arr) {
      this.map = ExtendedMap.fromArr(arr, 'studentHomeworkId')
    }
  }

  clear() {
    this.map.clear()
  }
}
